<template>
  <v-card>
    <v-card-title class="mt-2 d-flex align-center text-wrap">
      <component
        :is="icon"
        v-if="icon"
        class="mr-2 text-secondary"
        size="30"
        stroke-width="1.5" />
      {{ title }}
    </v-card-title>
    <v-card-text>
      <v-list>
        <v-list-item
          v-for="row in displayRows"
          :key="row.name">
          <v-divider
            v-if="row.isTotal"
            class="total-divider mb-2"
            thickness="2" />
          <div class="d-flex justify-space-between align-start">
            <h3 :class="['text mr-2', { 'font-weight-bold': row.isTotal }]">{{ row.name }}</h3>
            <div class="text-right">
              <v-skeleton-loader
                v-if="row.isLoading"
                type="text"
                width="80" />
              <template v-else>
                <div :class="['text-h4', row.dimmed ? 'font-weight-regular text-medium-emphasis' : 'font-weight-medium']">
                  {{ row.value }}
                </div>
                <div
                  v-if="row.subText"
                  class="text-body-2 text-medium-emphasis">
                  {{ row.subText }}
                </div>
              </template>
            </div>
          </div>
          <v-divider v-if="row.showDivider" />
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { LocationValueListProps, LocationValueRow } from '@/models/metricDefinitions';

const props = defineProps<LocationValueListProps>();

type DisplayRow = LocationValueRow & { isTotal?: boolean; showDivider: boolean };

// The total is set apart by its own stronger divider, so the row above it drops the plain one.
const displayRows = computed((): DisplayRow[] => {
  const rows = props.rows.map((row, index) => ({ ...row, showDivider: !props.total || index < props.rows.length - 1 }));

  return props.total ? [...rows, { ...props.total, isTotal: true, showDivider: false }] : rows;
});
</script>

<style scoped>
.total-divider {
  border-color: rgba(var(--v-theme-inputBorder), 0.5);
}
</style>
